import React from 'react'
import { Col, Row } from 'react-bootstrap';
import { getItemText, getUpdateInfo } from './helpers';
import { getDateAndTime } from '../../../../lib/utils';
import { tableComponent } from '../../../elements/historyTable';
import { getDisplayUserName } from '../../../../lib/userUtils';

const SingleHistoryElement = ({ item, users, statuses, priorities, modules, labels, testSuites, fieldConfigs }) => {
 if (!item || item.length === 0) return null;

  const createdBy = getDisplayUserName(item[0]?.test_case_history_user);
  const itemData = getItemText(item[0]);
  const creationDate = getDateAndTime(item[0]?.created_at, users, statuses);

   return (
      <Row>
        <Col>
          <p>
            <strong>{createdBy}</strong> {itemData} - {creationDate}
          </p>
          {item?.length === 1 ? (
            ['UPDATED_TEST_CASE'].includes(item[0].event_type) ? (
              tableComponent(getUpdateInfo(item[0], statuses, priorities, users, modules, labels, testSuites, fieldConfigs))
            ) : (
              <React.Fragment>{getUpdateInfo(item[0], statuses, priorities, users, modules, labels, testSuites)}</React.Fragment>
            )
          ) : item?.length > 1 && ['ADDED_TEST_STEP', 'ADDED_ATTACHMENT_TESTSTEP', 'ADDED_ATTACHMENT_TESTCASE', 'REMOVED_ATTACHMENT_TESTCASE', 'REMOVED_ATTACHMENT_TESTSTEP', 'UPDATED_TEST_STEP'].includes(item[0].event_type) ? (
            item.map((history, index) => (
              <React.Fragment key={history.id || index}>{getUpdateInfo(history, statuses, priorities, users, modules, labels, testSuites, fieldConfigs)}</React.Fragment>
            ))
          ) : (
            tableComponent(item.map((history, index) => (
              <React.Fragment key={history.id + index}>
                {getUpdateInfo(history, statuses, priorities, users, modules, labels, testSuites, fieldConfigs)}
              </React.Fragment>
            ))
            )
          )}
        </Col>
      </Row>
    );
}

export default SingleHistoryElement
